import {defaultState} from "./state";

const mutations = {
  UPDATE_UNPUBLISH_PAGE_LIST: (state, {type, pageId}) => {
    const unpublishList = state.pages[type].unpublishList;
    if (unpublishList.includes(pageId)) {
      const currentPageIndex = unpublishList.indexOf(pageId);
      return unpublishList.splice(currentPageIndex, 1);
    } else {
      unpublishList.push(pageId);
    }
  },
  SET_SELECT_ALL: (state, {pageType, pageList}) => {
    const listId = pageList.map((page) => page.id);
    const unpublishList = state.pages[pageType].unpublishList;
    const isSelectAll = listId.every(id => unpublishList.includes(id));

    listId.map(id => {
      const isInNewAssignedList = unpublishList.includes(id);

      if (isInNewAssignedList) {
        if(!isSelectAll) return;
        const currentProductIndex = unpublishList.indexOf(id);
        return unpublishList.splice(currentProductIndex, 1);
      }

      unpublishList.push(id);
    });
  },
  RESET_SELECT_PAGE: (state, pageType) => {
    state.pages[pageType].unpublishList = [];
  },
  RESET_DATA: (state) => {
    return Object.assign(state, defaultState());
  },
  SET_DISABLED_CONFIRM: (state, value) => {
    state.disabledConfirm = value;
  },
  SET_CHOOSED_PLAN: (state, value) => {
    state.choosedPlan = value;
  },
  PAGE_UPDATE_QUERY: (state, {type, value}) => {
    state.pages[type].query = value;
  },
  OPEN_UNPUBLISH_MODAL: (state, type) => {
    state.unpublishPageType = type;
    state.isOpenUnpublishModal = true;
  },
  CLOSE_UNPUBLISH_MODAL: (state) => {
    state.isOpenUnpublishModal = false;
  },
  TOGGLE_BLOCK_MODAL: (state, value) => {
    state.openBlockModal = value;
  }
};
export default mutations;
